export default __webpack_public_path__ + "static/media/E_Estojo.5d65b0f4.mp3";